var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nt-skeleton",style:({background: _vm.bgColor, paddingBottom: _vm.paddingBottom, width:_vm.width+'px'})})}
var staticRenderFns = []

export { render, staticRenderFns }